export default __webpack_public_path__ + "static/media/touch_sleeve.8dafa997.png";